import { Controller } from "@hotwired/stimulus"

// Simple controller for testing notification sounds in settings
export default class extends Controller {
  play() {
    const select = document.getElementById("notification_sound_select")
    if (!select) return

    const soundFile = select.value
    if (!soundFile) return

    const audio = document.getElementById("sound-preview")
    if (!audio) return

    audio.src = `/sounds/${soundFile}`
    audio.currentTime = 0

    const playPromise = audio.play()
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.debug("Audio play prevented:", error)
      })
    }
  }
}
